<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" title="Nuevo" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" title="Exportar" class="btn btn-outline-success" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<app-especie-eppo-popup (selected)="onAcceptDialogEspecieEppo($event)" [esImportacion]="true"></app-especie-eppo-popup>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Grupos Especies FR</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-12">
                                    <label class="col-form-label" for="inpDescripcion">Descripción</label>
                                    <input formControlName="Descripcion" name="Descripcion" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="200">
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="">Grupo</label>
                                    <ng-select [items]="listGrupo"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdGrupo"
                                               loadingText="Cargando..."
                                               [loading]="!listGrupo"
                                               notFoundText="Grupo no encontrado"
                                               placeholder="-- Seleccione un Grupo --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectGrupo()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="">Forma</label>
                                    <ng-select [items]="listForma"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdForma"
                                               loadingText="Cargando..."
                                               [loading]="(!listForma && (form.value.IdGrupo > 0))"
                                               notFoundText="Forma no encontrada"
                                               placeholder="-- Seleccione una Forma --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectForma()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intPais">Código Eppo</label>
                                    <div class="input-group">
                                        <input readonly title="" formControlName="CodigoEppo" class="form-control" id="" type="text">
                                        <span class="input-group-btn">
                                            &nbsp;<button name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button"
                                                          title="Buscar Código Eppo" (click)="onSearchCodigoEppo()">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Grupo Países FR</label>
                                    <ng-select [items]="listGruposPaisesFr"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdGrupoPaisFr"
                                               loadingText="Cargando..."
                                               [loading]="!listGruposPaisesFr"
                                               notFoundText="Grupo Países Fr no encontrado"
                                               placeholder="-- Seleccione un Grupo Países Fr --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdGrupoPaisFr')">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Porcentaje</label>
                                    <input formControlName="Porcentaje" numbersOnly name="Porcentaje" title=""
                                           class="form-control" id="inpNombre" type="text" value="" maxlength="3"><!--maxlength="10"-->

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoEspecie','maxlength')">
                                        El Porcentaje debe tener máximo 3 dígitos
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activo"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <!--DATAGRID-->

    <div *ngIf="searchingButton" class="row">
        <div class="col-md-12">
            <div class="card card-accent-success">
                <div class="card-header-buscador">
                    <i class="fa fa-align-justify"></i> Listado de Grupos Especies FR
                </div>

                <div class="card-body-grid">

                    <p-table #tableSearch autoLayout="true" [value]="resultGruposEspecieFr.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                             [columns]="cols" sortField="Descripcion" [rows]="resultGruposEspecieFr?.PageSize" [totalRecords]="resultGruposEspecieFr.TotalCount" [loading]="loading"
                             styleClass="table table-responsive-sm  table-striped table-sm"
                             [ngClass]="displayGridHidden(resultGruposEspecieFr.ResultList)">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display':col.display}" [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                </th>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field!=='Link' && col.field!=='Activo' && col.field!=='Porcentaje'">
                                        {{rowData[col.field]}}
                                    </span>
                                    <span *ngIf="col.field==='Activo'">
                                        {{rowData[col.field] | siNo}}
                                    </span>
                                    <span *ngIf="col.field==='Porcentaje'">
                                        {{rowData[col.field]/100 | percent}}
                                    </span>
                                    <div *ngIf="col.field==='Link'" class="btn-group">
                                        <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                class="btn btn-sm btn-warning">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                class="btn btn-sm btn-danger">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                        </ng-template>
                    </p-table>

                    <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                    <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                </div>

            </div>
        </div>
    </div>

</form>
